import {
  resolveResearchEntrySourceFromRoute,
  setResearchEntrySource
} from '@/pages/aiAssistant/researchMode/composables/trackResearchMode';

// AI进宝 · 研究模式
import { PAGE_LEVEL } from '@/constants';

const IRM_EMBED_SOURCE = 'irm';

function redirectIrmEmbedToThirdPartyResearch(to) {
  if (to.query?.source !== IRM_EMBED_SOURCE) return true;
  // 目标已是第三方研究模式：无需再重定向。否则带着 source=irm 重定向到自身会触发
  // Vue Router「Infinite redirect in navigation guard」死循环（该守卫被两个研究模式路由共用）。
  if (to.name === 'thirdpartyAiChatResearch') return true;

  return {
    name: 'thirdpartyAiChatResearch',
    query: { ...to.query },
    replace: true
  };
}

/**
 * 进入研究模式路由：IRM 重定向 + 写入 020-1-1 入口来源供页面 onMounted 消费。
 * @param {import('vue-router').RouteLocationNormalized} to
 * @param {import('vue-router').RouteLocationNormalized} from
 * @param {import('vue-router').NavigationGuardNext} next
 * @returns {void}
 */
export function beforeEnterResearchMode(to, from, next) {
  const redirect = redirectIrmEmbedToThirdPartyResearch(to);
  if (redirect !== true) {
    next(redirect);
    return;
  }
  setResearchEntrySource(resolveResearchEntrySourceFromRoute(from));
  next();
}

export default {
  path: '/aiChat/research',
  name: 'aiChatResearch',
  component: () => import(/* webpackChunkName: 'ai-research-mode' */ '@/pages/aiAssistant/researchMode/index'),
  beforeEnter: beforeEnterResearchMode,
  meta: {
    localeModules: [
      'aiChat',
      'aiAssistant',
      'researchEditor',
      'aiChatConstants',
      'openClaw',
      'cloudDocument',
      'report',
      'summary',
      'daily',
      'eventSignal',
      'roadshow',
      'aiDataUsage'
    ],
    title: 'routers.ai_chat_ai_jinbao',
    name: 'routers.ai_chat_research_mode',
    pageLevel: PAGE_LEVEL.SECOND,
    parent: '/aiChat/index',
    keepAlive: false,
    hideBreadcrumb: true,
    hideOuterBreadcrumb: true,
    // 不设置 electronSingle/pageLevel.FIRST：与任务模式（openClawChat）保持一致，
    // 在客户端下切换到研究模式时复用当前 AI 进宝 tab，而不是新开一个 tab
    // AI进宝三模式（聊天/研究/任务）共用同一个客户端顶部tab
    tabGroup: '/aiChat/index'
  }
};
